import React from 'react';
import PropTypes from 'prop-types';

import { Container, LineBar, PercentageLine, Percentage } from './style';
import theme from '../../theme';

const ProgressBar = ({
  height = 6,
  percentage = 0,
  hasPercentage = false,
  color = theme().colors.incompleteColor,
  bgColor = theme().colors.midGray,
  rearrange,
  mb,
}) => (
  <Container rearrange={rearrange} mb={mb}>
    <LineBar bgColor={bgColor} className="external-bar" height={height}>
      <PercentageLine
        percentage={percentage}
        color={color}
        height={height}
        className="inner-bar"
      />
    </LineBar>
    {hasPercentage && (
      <Percentage className="percentage">{percentage || 0}%</Percentage>
    )}
  </Container>
);

ProgressBar.propTypes = {
  height: PropTypes.number,
  percentage: PropTypes.number,
  hasPercentage: PropTypes.bool,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  rearrange: PropTypes.bool,
  mb: PropTypes.number,
};

export default ProgressBar;
